import React from "react";
import styled from "styled-components/macro";
import { StaticFeature } from "./FeaturesHint";

const SImage = styled.img`
  width: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: top;
`;

type Props = {
  feature: StaticFeature;
};

const FeaturesHintImage: React.FC<Props> = ({ feature }) => {
  return <SImage src={feature.image} alt="Image displaying a feature" />;
};

export default FeaturesHintImage;
